import Tabs from './src/Tabs.vue'

export default Tabs


// WEBPACK FOOTER //
// ./~/iexplore/components/tabs/index.js